import "./naf-insurance-card.scss";
import { useState } from "react";
import {
  NAF_INSURANCE_BANNER_CTA,
  NAF_INSURANCE_BANNER_LINE1,
  NAF_INSURANCE_BANNER_LINE2,
} from "utilities/Constant";
import { trackFSInsuranceCardClick } from "utilities/full-story";
import { useInsuranceFullStoryTrackingProps } from "hooks/useInsuranceFullStoryTrackingProps";
import NafInsurancePanel from "pages/dashboard/advertisements/naf-insurance-panel/NafInsurancePanel";
import { Button } from "components/v2/button/Button";

export default function NafInsuranceCard() {
  const [isInsuranceModalOpen, setIsInsuranceModalOpen] = useState(false);
  const insuranceTrackingProps = useInsuranceFullStoryTrackingProps();

  const handleCtaClick = () => {
    trackFSInsuranceCardClick(insuranceTrackingProps);
    setIsInsuranceModalOpen(true);
  };

  return (
    <>
      <div className="naf-insurance-card" data-fs-element="InsuranceAdBanner">
        <div className="naf-insurance-card__body">
          <h6 className="naf-insurance-card__body-text paragraph-large-medium">{NAF_INSURANCE_BANNER_LINE1}</h6>
          <h6 className="naf-insurance-card__body-text label-large-regular">{NAF_INSURANCE_BANNER_LINE2}</h6>
          <div className="naf-insurance-card__btn-container">
            <Button
              variant="outline"
              label={NAF_INSURANCE_BANNER_CTA}
              className="naf-insurance-card__btn paragraph-small-medium"
              onClick={handleCtaClick}
            />
          </div>
        </div>
      </div>
      {isInsuranceModalOpen && (
        <NafInsurancePanel
          onClose={() => setIsInsuranceModalOpen(false)}
        />
      )}
    </>
  );
}
